import React from 'react';

export const LoginHeader = () => (
    <>
        <h2 className="fs-20 fw-bolder mb-4">Iniciar sesión</h2>
        <h4 className="fs-13 fw-bold mb-2">Inicia sesión en tu cuenta</h4>
        <p className="fs-12 fw-medium text-muted">
            Gracias por regresar, accede ingresando tu correo electrónico y contraseña.
        </p>
    </>
);
